module.exports = __webpack_public_path__ + "static/img/8.0361977.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/1/sp/8.png
// module id = 7/4w
// module chunks = 0